module.exports = __webpack_public_path__ + "static/media/42x38-8.3ad986a2.png";